<template>
    <div id="searchContainer">
        <div class="searchBar">
            <div class="form">
                <span><input ref="search_keyword" type="text" :value="keyword" placeholder="请输入感兴趣的关键词，试试看~" name="kewword"></span>
                <button @click="searchRes"></button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        searchId: String,
        keyword: {
            type: String,
            default: ''
        },
        onSearch: {
            type: Function,
            default: undefined,
            require: false
        }
    },
    data() {
        return {
        }
    },
    methods: {
        searchRes(){
            let keyword=this.$refs.search_keyword.value
            if(keyword.trim().length==0){
                this.$toast.bottom('请输入关键字')
                return;
            }
            if(keyword.trim().length>50){
                this.$toast.bottom('请输入合适关键字，最长不能超过50个字符')
                return;
            }
            this.onSearch(keyword);
        }
    }
}
</script>
<style>
#searchContainer{
    position:relative;
    width:100%;
    height:100%;
}
.searchBar{
    position: relative;
    margin:5px 10px;
    border-radius:18px;
	border:1px solid #EFF0F2;
	background:#EFF0F2;
}
.searchBar .form {
    position:relative;
    height:35px;
}
.searchBar span {
    position: absolute;
    display:inline-block;
    height:35px;
    top:0;
    right:40px;
    left:10px;
}
.searchBar span input{
    position:absolute;
    background:#EFF0F2;
    top:0;
    left:0;
    text-indent: 5px;
    height:35px;
    outline:none;
    font-size:14px;
    width:100%;
}
.searchBar button {
	height:40px;
	width:40px;
	cursor:pointer;
    position:absolute;
    border:none;
    outline:none;
    background:none;
	top:-3px;
    right:10px;
    background-image:url("../assets/images/search.png") ;
    background-repeat:no-repeat;
    background-position: center right;
    background-size:20px 20px;
    -moz-background-size:20px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchBar.vue